export const defaultSelectedDateFrom = () => {
    let d = new Date();
    return `${d.getFullYear()}01`;
};
export const defaultSelectedDateUp = () => {
    let d = new Date();
    return `${d.getFullYear()}${d.getMonth()+1}`;
};
export default {
  show_pdf:false,
  clients:[],
  params: {
      year_month_from: defaultSelectedDateFrom(),
      year_month_up: defaultSelectedDateUp(),
      provider: [],
      type: 1,
  },
  mails: [],
  file:null,
  paramsEmail:{
      to:[],
      subject:null,
      body:null,
      filename:null

  },
  pathPdf:null,
  preloader:false,
  authenticatedRole:''
};



// WEBPACK FOOTER //
// ./src/modules/certificates-retentions/state.js